module.exports = __webpack_public_path__ + "assets/img/page2.6405db7b.png";